
export class PaginationArgument {

  pageSize: number = 50;

  pageIndex: number = 1;
}